import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { CustomLinkModule } from '../../custom-link/custom-link.directive.module'
import { SvgModule } from '../../../shared/svg/svg.module'
import { ContentRightRailLayoutComponent } from './content-right-rail-layout.component'
import { ErrorModule } from '../../error/error.module'
import { GridContainerModule } from '../../_containers/grid-container/grid-container.module'
import { FilterableGridModule } from '../../_containers/filterable-grid/filterable-grid.module'
import { FilterableContainerModule } from '../../_containers/filterable-container/filterable-container.module'
import { MessageModule } from '../../message/message.module'
import { ImageWithButtonsModule } from '../../image-with-buttons/image-with-buttons.module'
import { ContainerModule } from '../../container/container.module'
import { ExpandableTextModule } from '../../expandable-text/expandable-text.module'
import { LazyLoadModule } from 'lazy-load'
import { AdComponentModule } from '../../ad/ad.component.module'
import { AdhesionFooterModule } from '../../adhesion-footer/adhesion-footer.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadModule,
    CustomLinkModule,
    SvgModule,
    ErrorModule,
    MessageModule,
    ContainerModule,
    GridContainerModule,
    FilterableGridModule,
    FilterableContainerModule,
    ImageWithButtonsModule,
    ExpandableTextModule,
    AdComponentModule,
    AdhesionFooterModule
  ],
  declarations: [ContentRightRailLayoutComponent],
  exports: [ContentRightRailLayoutComponent]
})
export class ContentRightRailLayoutModule {}
